import { useNavigate } from 'react-router-dom';
import styles from './TermsPage.module.css';
import GeneralDoc from '@/assets/docs/GeneralDoc.pdf';
import A_Logo from '@/components/A_Atoms/A_Logo/A_Logo';
import cn from 'classnames';
import { PATHS } from '@/constants/paths';

export default function TermsPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(PATHS.HOME);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <button type='button' onClick={handleBack} className={styles.button}>
            <A_Logo variant='withLabel' />
          </button>
          <h1 className={cn(styles.title, 'text-h-2')}>
            Условия использования и политика конфиденциальности
          </h1>
        </div>
        <div className={styles.frameWrapper}>
          <iframe
            className={styles.frame}
            src={GeneralDoc}
            title='Условия использования и политика конфиденциальности'
          />
        </div>
      </div>
    </div>
  );
}
